import CrudModule from "@/components/CrudModule";
import { rupees } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function Investments() {
    return (
        <CrudModule
            testid="investments-page"
            eyebrow="Investments"
            title="Stocks, funds, and the long game."
            subtitle="One place for shares, mutual funds, PPF, NPS and bonds."
            endpoint="/investments"
            emptyIcon={TrendingUp}
            emptyTitle="No investments tracked"
            emptyBody="Add your equities, mutual funds, PPF, NPS or bonds — at least the current market value."
            fields={[
                { key: "inv_type", label: "Type", type: "select", required: true, defaultValue: "mutual_fund",
                  options: [
                    { value: "stocks", label: "Stocks / Equity" },
                    { value: "mutual_fund", label: "Mutual Fund" },
                    { value: "ppf", label: "PPF" },
                    { value: "nps", label: "NPS" },
                    { value: "bond", label: "Bond / Debenture" },
                    { value: "other", label: "Other" },
                  ] },
                { key: "name", label: "Name", required: true, placeholder: "Axis Bluechip, RIL, NPS Tier 1…" },
                { key: "broker", label: "Broker / Folio", placeholder: "Zerodha, KFintech…" },
                { key: "invested_amount", label: "Invested amount (₹)", type: "number" },
                { key: "current_value", label: "Current value (₹)", type: "number" },
                { key: "notes", label: "Notes", type: "textarea" },
            ]}
            columns={[
                { key: "inv_type", label: "Type",
                  render: (r) => <span className="capitalize">{(r.inv_type || "").replace("_", " ")}</span> },
                { key: "name", label: "Name" },
                { key: "broker", label: "Broker / Folio" },
                { key: "invested_amount", label: "Invested", render: (r) => <span className="font-mono">{rupees(r.invested_amount)}</span> },
                { key: "current_value", label: "Current", render: (r) => <span className="font-mono">{rupees(r.current_value)}</span> },
            ]}
        />
    );
}
